import debounce from 'debounce';

export default {
  data() {
    return {
      mixinsrcDebouncedMethodNames: {},
    };
  },
  methods: {
    rcDebounce(func, wait = 300, immediat) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        func();
      }, wait);
    },
  },
};
